import { getStoredSelectedCluster } from './clusterSwitch';

/**
 * Decode Cognito ID token payload (client-side only — for routing/UI, not auth).
 */
export function getCognitoClusterFromIdToken(idToken) {
  if (!idToken) return 'default';
  try {
    const part = idToken.split('.')[1];
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = JSON.parse(atob(b64));
    return json['custom:clusterName'] || 'default';
  } catch {
    return 'default';
  }
}

/**
 * get-user-info returns an array of { cluster_name, runner_url, trimmed_cluster_name }.
 * Prefers locally stored cluster choice, then Cognito claim if present, else default/first.
 */
export function pickRunnerUrlFromUserInfo(info, idToken) {
  const stored = getStoredSelectedCluster();
  const tokenCluster = getCognitoClusterFromIdToken(idToken);
  const list = Array.isArray(info)
    ? info
    : (info && info.runner_url
        ? [{ cluster_name: info.cluster_name || 'default', runner_url: info.runner_url }]
        : []);
  if (!list.length) return null;
  const match =
    (stored && list.find((x) => x.cluster_name === stored)) ||
    list.find((x) => x.cluster_name === tokenCluster) ||
    list.find((x) => x.cluster_name === 'default') ||
    list[0];
  return match?.runner_url || null;
}
